<template>
  <div style="padding-top: 20px">
      <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}} <v-btn class="primary--text" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
     
      <v-btn color="primary" class="white--text" round @click="addItem()">Add</v-btn>
       <v-spacer></v-spacer>
      <v-text-field max-width="50px" v-model="search" label="Search"></v-text-field>
    </v-toolbar>
    <v-data-table :loading="loading" :items="serviceLevelAgreements" :headers="headers" :search="search" style="cursor: pointer">
      <template v-slot:items="props">
         <td class="text-xs-center">
          <v-icon @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td class="text-xs-center" @click="rouerLink(props.item)">{{props.item.type}}</td>
        <td class="text-xs-center" @click="rouerLink(props.item)">{{props.item.name}}</td>
        <td class="text-xs-center" @click="rouerLink(props.item)">{{props.item.customerOrganisation.name}}</td>
        <td class="text-xs-center" @click="rouerLink(props.item)">{{props.item.locationNetwork.name}}</td>
        <td class="text-xs-center" @click="rouerLink(props.item)">{{formatDate(props.item.startDate)}}</td>
        <td class="text-xs-center" @click="rouerLink(props.item)">{{formatDate(props.item.endDate)}}</td>
        <td class="text-xs-center" @click="rouerLink(props.item)">{{props.item.hours}}</td>
      </template>
    </v-data-table>
    <v-dialog v-model="addModal" persistent max-width="750px">
    <v-card flat color="white">
        <v-toolbar flat color="primary" >
            <h3 class="title white--text">Add SLA</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="addModal=false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text >
            <v-layout justify-center align-center wrap>
                <v-flex xs5 mx-1>
                    <v-select :items="slaTypes" v-model="item.type" label="Type"></v-select>
                </v-flex>
                <v-flex xs5 mx-1>
                    <v-text-field v-model="item.name" label="Name"></v-text-field>
                </v-flex>
                <v-flex xs5 mx-1>
                    <v-autocomplete v-model="item.customerOrganisationId" :items="customers" label="Customer" item-text="name" item-value="id"></v-autocomplete>
                </v-flex>
                <v-flex xs5 mx-1>
                    <v-autocomplete v-model="item.locationNetworkId" :items="locationNetworks" label="Network" item-text="name" item-value="id"></v-autocomplete>
                </v-flex>
                <v-flex xs5 mx-1>
                    <v-text-field type="number" v-model="item.hours" label="Monthly Hours"></v-text-field>
                </v-flex>
                <v-flex xs5 mx-1>
                    <v-text-field type="number" v-model="item.hourlyRate" label="Hourly Rate"></v-text-field>
                </v-flex>
                <v-flex xs5 mx-1>
                    <v-text-field type="number" v-model="item.afterHourRate" label="Overtime Hourly Rate"></v-text-field>
                </v-flex>
                <v-flex xs5 mx-1>
                    <v-text-field type="number" v-model="item.sundayAndPublicHolidayRate" label="Sunday & Public Holiday Hourly Rate"></v-text-field>
                </v-flex>
                <v-flex xs5 mx-1>
                    <v-menu :close-on-content-click="false">
                  <v-text-field
                    :value="item.startDate"
                    slot="activator"
                    required
                    label="Start Date"
                    prepend-icon="date_range"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="item.startDate"></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex xs5 mx-1>
                     <v-menu :close-on-content-click="false">
                  <v-text-field
                    :value="item.endDate"
                    slot="activator"
                    required
                    label="End Date"
                    prepend-icon="date_range"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="item.endDate"></v-date-picker>
                </v-menu>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-layout justify-center>
                <v-btn v-if="
                item.type &&
                item.name &&
                item.customerOrganisationId &&
                item.locationNetworkId &&
                item.hours &&
                item.hourlyRate &&
                item.afterHourRate &&
                item.sundayAndPublicHolidayRate &&
                item.startDate &&
                item.endDate
                " round class="white--text" color="primary" @click="saveNew()">Save</v-btn>
                <v-btn v-else disabled round class="white--text" color="primary">Save</v-btn>

            </v-layout>
        </v-card-actions>
    </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api.js";
import dateformat from "dateformat";
export default {
  data() {
    return {
      loading:false,
      addModal: false,
      customers: [],
      item: {},
      locationNetworks: [],
      search: "",
      serviceLevelAgreements: [],
      slaTypes: ['Access Control', 'Camera', 'Fibre', 'Other'],
      snackbar: false,
      text: '',
      y: 'top',
      headers: [
        {
          text: "Action",
          align: "center"
        },
        {
          text: "Type",
          align: "center",
          value: "type",
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Customer",
          align: "center",
          value: "customerOrganisation.name",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
        {
          text: "Start Date",
          align: "center",
          value: "startDate",
        },
        {
          text: "End Date",
          align: "center",
          value: "endDate",
        },
        {
          text: "Monthly Hours",
          align: "center",
          value: "hours",
        },
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    addItem(){
 if (this.authCreate(this.$store.state.currentRoute)){
   this.addModal=true
 }
    },
    
    initialize() {
      this.getServiceLevelAgreements();
      this.getCustomers()
      this.getNetworks()
    },
    async getServiceLevelAgreements() {
      this.loading=true
      await Api()
        .get("/sla")
        .then((response) => {
          this.serviceLevelAgreements = response.data;
          this.loading=false
        });
    },
    getCustomers(){
        Api().get('/organisation/subOrganisations/customers')
        .then(response=>{
            this.customers = response.data
        })
    },
    getNetworks(){
        Api().get('/locationNetworks')
        .then(response=>{
            this.locationNetworks = response.data
        })
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    deleteItem(item) {
        if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you would like to delete this Service Level Agreement?") &&
        Api()
          .put("/sla/" + item.id, {
            isActive: false,
            isDeleted: true
          })
          .then(response=>{
            this.getServiceLevelAgreements()
          })
        }
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    async saveNew(){
        await Api().post('/sla', this.item)
        .then(response=>{
            this.addModal = false
            this.item = {}
            this.text = 'Successfully added SLA!'
            this.snackbar = true
            this.getServiceLevelAgreements()
            
        })
    },
    rouerLink(item){
        this.$router.push({ path: "/serviceLevelAgreement/" + item.id });
    }
  },
};
</script>